var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cityLocation"},[_c('city-list',{on:{"selectedCity":_vm.selectedCid}}),_c('div',{staticClass:"areaMap"},[_c('ye',{attrs:{"cname":_vm.cname,"cate":2,"city_plate_id":_vm.currentArea}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }